import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { t } from 'translation'

import ContactFormSupport from '../components/Contact/ContactFormSupport'
import ContactFormSales from '../components/Contact/ContactFormSales'

import LogoLoginImg from 'assets/logo_tr.png'

import { authFail, resetAuthError } from 'store/actions'

import BgLoginImg from 'assets/woman.jpg'

const ContactForm = function ContactForm({ authError, authFail, resetAuthError }) {
  const [success, setSuccess] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [department, setDepartment] = useState('')

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
  }, [])

  const handleSelect = (e) => {
    setDepartment(e.target.value)
  }

  return (
    <section className="section login_mod">
      <div className="section_bg login_mod">
        <img className="section_bg_img" src={BgLoginImg} alt="background" />
      </div>
      <div className="section_in login_mod">
        <div className="logo login_mod">
          <img className="logo_img" src={LogoLoginImg} alt="Logo Music Care" />
        </div>
        <div className="tab_content_wrap auth_block v2_mod">
          <div className="tab_content login_mod active_tab contact_form">
            <h2 className="section_title v3_mod center_level_mod color_mod offset_v3_mod">
              {t('contactForm.CONTACT_US')}
            </h2>
            <div className="login_descr_text v3_mod">{t('contactForm.SUPPORT_INFO')}</div>

            <div className="form_controller login_mod">
              <dl className="form_cell form_cell_v1_mod">
                <dd className="form_field_wrap form_v3_mod">
                  <select
                    className="form_field v4_mod input"
                    component="select"
                    name="department"
                    id="department"
                    value={department}
                    onChange={handleSelect}
                    placeholder=""
                    disabled={submit || success}
                  >
                    <option value="">{`${t('contactForm.SELECT_TYPE')}`}</option>
                    <option value="sales">{`${t(
                      'contactForm.CUSTOMER_SERVICE'
                    )}`}</option>
                    <option value="support">{`${t(
                      'contactForm.TECHNICAL_SUPPORT'
                    )}`}</option>
                    required
                  </select>
                </dd>
              </dl>
            </div>
            {department === 'support' && (
              <ContactFormSupport formSubmit={setSubmit} setStatus={setSuccess} />
            )}
            {department === 'sales' && (
              <ContactFormSales formSubmit={setSubmit} setStatus={setSuccess} />
            )}
          </div>
          <div className="auth_adress">
            MUSIC CARE. 8, rue la Vacquerie - 75011 Paris - France. Tel :{' '}
            <a href="tel:+330952030334">+33 (0)9 52 03 03 34</a>
          </div>
        </div>
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth: { error } }) => ({
  authError: error,
})

const willMapDispatchToProps = { authFail, resetAuthError }

export default connect(mapStateToProps, willMapDispatchToProps)(ContactForm)
